export default {
  workstation: {
    tabs: {
      workstation: "Workstation",
    },
    filters: {
      withAll: "Con tutti",
      withoutAny: "Senza nessuno",
      withPlayer: "Con {{player}}",
      withoutPlayer: "Senza {{player}}",
      all: "Tutti",
      versusPosition: "vs {{position}}",
      starter: "Titolare",
      nonStarter: "Non titolare",
      starterAndNonStarter: "Titolare + non titolare",
      betType: "Tipo di scommessa",
      timeframe: "Periodo",
      splits: "Suddivisioni",
      with: "Con",
      without: "Senza",
      opponent: "Avversario",
    },
    actions: {
      applyFilter: "Applica filtro",
      applied: "Applicato",
    },
    banners: {
      notPlayingToday: "{{entity}} non gioca oggi",
    },
    sections: {
      stats: "Statistiche",
      seasonStats: "Statistiche stagione",
      last3Seasons: "Ultime 3 stagioni",
      batterVsPitcherGamelog: "Vedi registro battitore vs lanciatore",
    },
    stats: {
      perGame: "A partita",
      total: "Totale",
      timeframe: "Periodo",
      filters: "Filtri",
      season: "Stagione",
    },
    headers: {
      type: "Tipo",
      hitRate: "Tasso di successo",
      odds: "Quote",
      stat: "Stat",
      average: "Media",
    },
    outcomes: {
      covered: "Coperto",
      yes: "Sì",
      no: "No",
      win: "W",
      loss: "L",
      tie: "TIE",
    },
    alerts: {
      imageSavedToDevice: "Immagine salvata sul dispositivo",
    },
  },
};
